<div *ngIf="vm$ | async as vm">
  <div *ngIf="(vm.unidadMetas | metaCriterios: unidadMetaId)?.length > 0">
    <div>
      <!--Manejo del idioma-->
      <h4>Criterios</h4>
    </div>
  </div>
  <div *ngFor="let criterion of (vm.unidadMetas | metaCriterios: unidadMetaId)">
    <!-- 
    <h2>{{criterion.nombre}}</h2>
    <div *ngFor="let criterio of criterion.hijos" class="descriptores">
      <div class="criterios-container">
        <div class="descriptores-initials">
          <span [class]="'descriptores-initials-bgr' + criterio.escala">{{criterio.escala}}</span>
        </div>
        <div class="descriptores-p">
          <p>{{criterio.nombre}}</p>
        </div>
      </div>
    </div>
     -->

    <!-- 
    <mat-list style="min-width: 500px;">
      <mat-list-item lines="1">
        <span matListItemTitle>{{criterion.nombre}}</span>
        <div *ngFor="let criterio of criterion.hijos">
          <span matListItemLine>
            {{(vm.escalas | escalaCriterio: criterio.escalaId)?.nombre}}: {{criterio.nombre}}
          </span>
        </div>
      </mat-list-item>
    </mat-list>
     -->

    <mat-card>
      <mat-card-header>
        <mat-card-title>
          {{criterion.nombre}}
        </mat-card-title>
        <!-- <mat-cad-subtitle>
          <strong>
            {{criterion.nombre}}
          </strong>
        </mat-cad-subtitle> -->
      </mat-card-header>
      <mat-card-content>
        <div *ngFor="let criterio of criterion.hijos">
          <strong>
            {{(vm.escalas | escalaCriterio: criterio.escalaId)?.nombre}}:
          </strong>  
           {{criterio?.nombre}}
        </div>
      </mat-card-content>
    </mat-card>

  </div>
</div>